import AngularLink from "../../../../global/components/AngularLink/AngularLink.vue";
import AsideRightBox from "../../../../global/components/AsideRightBox/AsideRightBox.vue";
import PuxTranslate from "../../../../global/components/PuxTranslate/PuxTranslate.vue";

// @vue/component
export default {
  name: "AntragWarningBoxGegenpruefenInaktive",
  components: {
    AngularLink,
    AsideRightBox,
    PuxTranslate,
  },
  props: {
    antragstellerPk: {
      type: String,
      required: false,
      default: undefined,
    },
    gegenpruefenInaktive: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      optionsAsideRightBoxWarning: {
        icon: "warning",
        toggle: false,
      },
    };
  },
  computed: {
    isBoxVisible() {
      return this.gegenpruefenInaktive && this.antragstellerPk;
    },
  },
};
